// extracted by mini-css-extract-plugin
module.exports = {"main":"SubTitles_main__324uA"};